import {
  PrivateImg,
  type PrivateImgProps,
} from "@winamp/media-upload/BytescaleContext/PrivateImg.js";
import { Link } from "@winamp/ui/components/Link/Link.js";
import type React from "react";
import { classNames } from "../../utils/classNames";
import { CoverPlaceholder } from "../CoverPlaceholder";

type GridCardCoverProps = Omit<React.ComponentPropsWithoutRef<"img">, "src"> & {
  src: string | null;
  type: "image" | "audio" | "video";
  options?: PrivateImgProps["options"];
  to?: string;
};

const DEFAULT_OPTIONS = {
  transformationParams: {
    w: 512,
    h: 512,
  },
} as const;

function ContentCover({
  className,
  type,
  children,
  options = DEFAULT_OPTIONS,
  ...props
}: GridCardCoverProps) {
  return (
    <div
      className={classNames(
        "transition-all group relative w-full h-auto aspect-square rounded-2xl overflow-hidden",
        "after:content-[''] after:z-10 after:absolute after:inset-0 md:after:opacity-0 after:opacity-100 after:group-hover:opacity-100 after:transition-opacity after:duration-300 after:bg-gradient-to-t after:from-black/60 after:to-black/10",

        className,
      )}
      data-slot="cover"
    >
      <PrivateImg
        className="w-full aspect-square rounded-2xl object-cover"
        {...props}
        options={options}
      >
        {type === "audio" && (
          <CoverPlaceholder className="w-full h-auto aspect-square rounded-2xl" />
        )}
      </PrivateImg>

      {children}
    </div>
  );
}

export function GridCardCover({ to, ...props }: GridCardCoverProps) {
  return (
    <>
      {to ? (
        <Link to={to}>
          <ContentCover {...props} />
        </Link>
      ) : (
        <ContentCover {...props} />
      )}
    </>
  );
}
